<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6674 14.1685L11.0842 17.5032"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3348 14.1686H5.66535C3.36356 14.1686 1.49695 12.302 1.49695 10.0002V10.0002C1.49695 7.6984 3.36356 5.83179 5.66535 5.83179H12.3348C14.6366 5.83179 16.5032 7.6984 16.5032 10.0002V10.0002C16.5032 12.302 14.6366 14.1686 12.3348 14.1686Z"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.00009 1.66333V3.33069"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.3348 2.49707L11.5011 3.33075"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.66541 2.49707L6.49909 3.33075"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.00012 11.6675C9.92098 11.6675 10.6675 10.921 10.6675 10.0001C10.6675 9.07927 9.92098 8.33276 9.00012 8.33276C8.07927 8.33276 7.33276 9.07927 7.33276 10.0001C7.33276 10.921 8.07927 11.6675 9.00012 11.6675Z"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.33266 14.1685L6.91582 17.5032"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.78455 17.5033H12.2156"
      :stroke="clr"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
